import React from 'react';


import { Circle, CircleBg, CircularChart, Percentage } from './styles';


interface Props {
    percentage: number;
    size: string;
}
const Loading: React.FC<Props> = ({ percentage, size }) => {

    return (
        <CircularChart viewBox="0 0 36 36" className="blue" size={size}>
            <CircleBg
                d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <Circle
                percentage={`${(percentage*100).toFixed(0)}, 100`}
                d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <Percentage x="18" y="20.35" className="percentage">{(percentage*100).toFixed(2)}%</Percentage>
        </CircularChart>
    );
}

export default Loading;